module.exports = __webpack_public_path__ + "static/img/login_zs_01.e267006f.png";